/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import {
  ContextProvider,
  updateApiConfig
} from '../../../../context/ApiContext';
import './PortfolioEnergyVDTheme.scss';
import IEnergyManagementProps from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import PortfolioEnergyViewDetailComponent from './PortfolioEnergyViewDetailComponent';
import { withLocalization } from '../../../../locales/withLocalization';

const PortfolioEnergyViewDetailsWidget = (props: IEnergyManagementProps) => {
  const { connectorConfig, requestContext, emaasContext } = props;

  return (
    <ContextProvider
      value={updateApiConfig({
        connectorConfig,
        ...emaasContext
      })}
    >
      <DataContextProvider config={connectorConfig}>
        <div className="energy-viewdetails-dashboard">
          <PortfolioEnergyViewDetailComponent
            requestContext={requestContext}
            connectorConfig={connectorConfig}
            emaasContext={emaasContext}
          />
        </div>
      </DataContextProvider>
    </ContextProvider>
  );
};

export default withLocalization<IEnergyManagementProps>(
  PortfolioEnergyViewDetailsWidget
);
